import type { Locale, Messages } from '@repere/core';

/**
 * Version affichée : la version publiée et l'horodatage du build, dans la langue courante,
 * en heure de Paris.
 *
 * Volontairement lisible plutôt que technique — un parent qui signale un comportement
 * n'a pas à déchiffrer un condensat de commit pour dire quelle version il utilise.
 * L'heure reste celle de Paris quelle que soit la langue : c'est l'heure à laquelle le
 * build a été produit, pas celle du fuseau de qui le lit, et la faire varier ferait
 * mentir deux parents qui comparent la même version dans deux langues.
 *
 * Elle vit ici, et non dans la coquille, depuis que le pied de page ne s'affiche plus sur
 * téléphone : deux écrans la portent désormais — le pied sur grand écran, « Options »
 * partout — et une seconde copie du calcul finirait par annoncer deux versions.
 */
export function versionLisible(locale: Locale, messages: Messages): string {
  const build = new Date(__BUILD_TIME__);
  const horodatage = Number.isNaN(build.getTime())
    ? messages.coquille.versionInconnue
    : new Intl.DateTimeFormat(locale, {
        dateStyle: 'long',
        timeStyle: 'short',
        timeZone: 'Europe/Paris',
      }).format(build);
  return messages.coquille.version(__APP_VERSION__, horodatage);
}
